import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import cx from 'clsx';

import { useSnackbarContext } from './context';
import Snackbar from './Snackbar';
import type { ContainerProps } from './types';

import styles from './SnackbarContainer.module.css';

export const SnackbarContainer = ({
  portalTargetSelecter,
  className,
  closeInMilliseconds = 3200,
  style,
  ...props
}: ContainerProps) => {
  const { snackbar } = useSnackbarContext();

  const portalTarget = useMemo(() => {
    return typeof window !== 'undefined'
      ? (portalTargetSelecter &&
          document.querySelector(portalTargetSelecter)) ||
          document.body
      : null;
  }, [portalTargetSelecter]) as Element;

  if (typeof window === undefined || !portalTarget || !snackbar) return <></>;

  return createPortal(
    <div
      role="presentation"
      className={cx(styles.container, className)}
      style={style}
      {...props}
    >
      <Snackbar
        key={snackbar.id}
        {...snackbar}
        closeInMilliseconds={closeInMilliseconds}
      />
    </div>,
    portalTarget,
  );
};
